window.chartVermoegensverlauf = {
	data: {
		// Sonstiges
		startdatum: 0,
		enddatum: 0,
	},

	showLoading() {
		if (this.chart) this.chart.showLoading()
	},

	hideLoading() {
		if (this.chart) this.chart.hideLoading()
	},

	init() {
		this.chart = new Highcharts.stockChart("chart_vermoegensverlauf", {
			chart: {
				chartType: "liqui", // ["liqui", "steuer"]
				werteDarstellung: "nominal", // ["nominal", "real"]
				events: {
					selection: function (event) {
						return zoomIn(chartVermoegensverlauf, event)
					},
				},
			},

			tooltip: {
				pointFormatter: function () {
					if (this.y != 0) {
						return `<span>${this.series.name}: ${Highcharts.numberFormat(this.y, 0)}&nbsp;€</span>`
					} else return false
				},
			},

			yAxis: [
				{
					height: "60%",
				},
				{
					top: "70%",
					height: "30%",
					offset: 0,
				},
			],

			xAxis: {
				ordinal: false,
				min: this.data.startdatum,
				max: this.data.enddatum,
				anzeigeformat: "jahr",
				events: {
					afterSetExtremes: function (event) {
						const chart = event.target.chart,
							min = event.min,
							max = event.max

						updateDataGrouping(chart, min, max)
					},
				},
			},

			legend: {
				enabled: true,
			},

			plotOptions: {
				area: {
					stacking: "normal",
				},
			},

			series: this.seriesNettovermoegen,
		})

		// Wenn der Chart Zeitraum kleiner ist als die Monatsgrenze das DataGrouping deaktivieren
		updateDataGrouping(this.chart, this.data.startdatum, this.data.enddatum)
	},

	update() {
		if (!this.chart) return
		this.chart.showLoading()

		const seriesArrays = [this.seriesNettovermoegen, this.seriesGesamtvermoegen]
		const alleSeries = [].concat(...seriesArrays)

		alleSeries.forEach((serie) => {
			const s = this.chart.get(serie.id)
			if (s) {
				if (this.chart.options.chart.werteDarstellung === "real") {
					s.setData(serie.dataReal, false)
				} else {
					s.setData(serie.dataNominal, false)
				}
				s.options.dataNominal = serie.dataNominal
				s.options.dataReal = serie.dataReal
			}
		})

		// xAchse: Min und Max aktualisieren
		this.updateXAxisMinMax()

		this.chart.redraw({ duration: chartAnimationDuration })
		this.chart.hideLoading()
	},

	updateXAxisMinMax() {
		const seriesMaxValues = this.chart.series.map((serie) => (Array.isArray(serie.xData) ? serie.xData.slice(-1)[0] : undefined)),
			xAxisMaxValue = Math.max(this.data.enddatum, ...seriesMaxValues.filter((element) => element !== undefined))
		this.chart.xAxis[0].update({ min: this.data.startdatum, max: xAxisMaxValue })
	},

	updateYAxis(anzahl) {
		if (anzahl == 1) {
			this.chart.yAxis[0].update({ height: "100%" })
			this.chart.yAxis[1].update({ height: "0%", visible: false })
		} else {
			this.chart.yAxis[0].update({ height: "60%" })
			this.chart.yAxis[1].update({ height: "30%", top: "70%", offset: 0, visible: true })
		}
	},

	updateSeriesData(seriesData) {
		// Alle Series entfernen
		while (this.chart.series.length > 0) {
			this.chart.series[0].remove(false)
		}

		// Series hinzufügen
		seriesData.forEach((serie) => {
			this.chart.addSeries(serie, false)
		})

		// XAchse Max Data prüfen und ggf. aktualisieren
		this.updateXAxisMinMax()

		this.chart.redraw({ duration: chartAnimationDuration })
	},

	seriesNettovermoegen: [],

	seriesGesamtvermoegen: [],
}
